/* eslint-disable import/no-extraneous-dependencies */
import moment from "moment";

export const getLocalISODateString = (date) => {
  return `${moment(date).format("YYYY-MM-DD[T]HH:mm:ss[.000Z]")}`;
};
